/* assets/ymm-filter-apply.js
   YMM search bridge:
   - Keeps the full YMM selection in localStorage (ymm.selection.v11)
   - Mirrors current ?ymm=YEAR|MODEL|TRIM|ENGINE format for search links
   - Adds a hidden "ymm" field to search forms
   - Listens to the existing window "ymm:changed" / "ymm:reset" events
*/
(function () {
  const STORAGE_KEY = 'ymm.selection.v11';

  function clean(v) {
    return String(v || '').replace(/\s+/g, ' ').trim();
  }

  function normalizeSelection(sel) {
    sel = sel || {};
    return {
      year: clean(sel.year),
      make: clean(sel.make),
      model: clean(sel.model),
      model_name: clean(sel.model_name),
      body: clean(sel.body),
      trim: clean(sel.trim),
      engine: clean(sel.engine),
      label: clean(sel.label)
    };
  }

  function hasActive(sel) {
    sel = sel || {};
    return !!(
      sel.year ||
      sel.make ||
      sel.model ||
      sel.model_name ||
      sel.body ||
      sel.trim ||
      sel.engine ||
      sel.label
    );
  }

  function selectionFromStorage() {
    try {
      return normalizeSelection(JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}') || {});
    } catch {
      return {};
    }
  }

  function selectionFromUrl() {
    try {
      const u = new URL(location.href);
      const raw = u.searchParams.get('ymm');
      if (!raw) return {};

      const decoded = decodeURIComponent(raw || '');
      if (!decoded) return {};

      if (decoded.includes('|')) {
        const parts = decoded.split('|');
        return normalizeSelection({
          year: parts[0] || '',
          model: parts[1] || '',
          trim: parts[2] || '',
          engine: parts[3] || ''
        });
      }

      try {
        const json = JSON.parse(decodeURIComponent(atob(decoded)));
        return normalizeSelection({
          year: json.y || json.year || '',
          make: json.make || '',
          model: json.m || json.model || '',
          model_name: json.model_name || '',
          body: json.body || '',
          trim: json.t || json.trim || '',
          engine: json.e || json.engine || '',
          label: json.label || ''
        });
      } catch {
        return {};
      }
    } catch {
      return {};
    }
  }

  function readSelection() {
    let sel = selectionFromStorage();
    if (hasActive(sel)) return sel;

    sel = selectionFromUrl();
    if (hasActive(sel)) {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(sel)); } catch {}
      return sel;
    }

    return {};
  }

  function encodePipe(sel) {
    sel = normalizeSelection(sel);
    return [
      sel.year || '',
      sel.model || '',
      sel.trim || '',
      sel.engine || ''
    ].join('|');
  }

  function attachSearchForms(sel) {
    sel = normalizeSelection(sel);
    const forms = document.querySelectorAll('form[action*="/search"]');

    if (!hasActive(sel)) {
      forms.forEach(f => {
        const hid = f.querySelector('input[name="ymm"]');
        if (hid) hid.remove();
      });
      return;
    }

    forms.forEach(f => {
      if (f.__ymmBound) return;
      f.__ymmBound = true;

      f.addEventListener('submit', () => {
        try {
          const latest = readSelection();
          if (!hasActive(latest)) return;

          let hid = f.querySelector('input[name="ymm"]');
          if (!hid) {
            hid = document.createElement('input');
            hid.type = 'hidden';
            hid.name = 'ymm';
            f.appendChild(hid);
          }
          hid.value = encodeURIComponent(encodePipe(latest));
        } catch {}
      });
    });
  }

  window.addEventListener('load', function () {
    const sel = readSelection();
    if (hasActive(sel)) attachSearchForms(sel);
  });

  window.addEventListener('ymm:changed', function (ev) {
    const norm = normalizeSelection(ev && ev.detail ? ev.detail : readSelection());

    if (!hasActive(norm)) {
      try { localStorage.removeItem(STORAGE_KEY); } catch {}
      attachSearchForms({});
      return;
    }

    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(norm)); } catch {}
    attachSearchForms(norm);
  });

  window.addEventListener('ymm:reset', function () {
    try { localStorage.removeItem(STORAGE_KEY); } catch {}
    attachSearchForms({});
  });
})();